import request from '@/router/axios';
//查询角色列表(带分页)
export const searchRolePage = (data) => {
  return request({
    url: '/svolt-ess-boss-service/role/searchRolePage',
    method: 'post',
    data: data
  })
}
//添加角色
export const addRole = (data) => {
  return request({
    url: '/svolt-ess-boss-service/role/addRole',
    method: 'post',
    data: data
  })
}
//修改角色
export const updateRole = (data) => {
  return request({
    url: '/svolt-ess-boss-service/role/updateRole',
    method: 'post',
    data: data
  })
}
//删除角色
export const deleteRole = (data) => {
  return request({
    url: '/svolt-ess-boss-service/role/deleteRole',
    method: 'post',
    data: data
  })
}

//用户绑定角色
export const bindUserRoles = (data) => {
  return request({
    url: '/svolt-ess-boss-service/role/bindUserRoles',
    method: 'post',
    data: data
  })
}
//删除角色
export const searchUserBindRoles = (data) => {
  return request({
    url: '/svolt-ess-boss-service/role/searchUserBindRoles',
    method: 'post',
    data: data
  })
}
//查询角色资源树
export const searchRoleResourceTree = (data)=>{
  return request({
    url: '/svolt-ess-boss-service/role/searchRoleResourceTree',
    method: 'post',
    data: data
  })
}
export const searchRoleResourceTreeV2 = (data)=>{
  return request({
    url: '/svolt-ess-boss-service/roleV2/searchRoleResourceTreeV2',
    method: 'post',
    data: data
  })
}
//添加角色资源
export const addRoleResources = (data)=>{
  return request({
    url: '/svolt-ess-boss-service/roleV2/addRoleResources',
    method: 'post',
    data: data
  })
}
export default{
  searchRolePage,
  addRole,
  updateRole,
  deleteRole,
  bindUserRoles,
  searchUserBindRoles,
  searchRoleResourceTree,
  searchRoleResourceTreeV2,
  addRoleResources
}



// WEBPACK FOOTER //
// ./src/api/role.js